import { Icons } from '@shared/ui-components';

export const ServiceVariables = {
  name: 'Skema',
  icon: Icons.SkemaLogoIcon,
};
